// 使用 redux-persist 在 localStorage 的 item 名稱
export const localStoargePersistRoot = 'persist:root';

// TODO: 若無用，可移除
// 伺服器設定和寄件設定的欄位中斷點，裝置寬度小於 745px 時每個欄位會變成滿版
export const breakpointOfEmailAndEmailSettingInput = 745;
// 表單欄位的 layout 基準值
export const formItemColSpan = 12;

// time foramt
export const timeFormatYMDHMZ = 'YYYY-MM-DD HH:mm Z';
export const timeFormatYMDHM = 'YYYY-MM-DD HH:mm';
export const timeFormatYMDHMS = 'YYYY-MM-DD HH:mm:ss';

// 帳號方案
export const roleType = {
  default: 'default',
  annual: 'annual',
};

// 帳號 role feature
export const userRoleFeature = {
  sendSMS: 'SendSMS',
  downloadQRImage: 'DownloadQRImage',
  healthyForm: 'HealthyForm',
  surveyForm: 'SurveyForm',
  indexPage: 'IndexPage',
  badge: 'Badge',
  anonymousSurveyForm: 'AnonymousSurveyForm',
  mailServer: 'MailServer',
};

// 帳號方案，目前僅應用在個人專屬頁面，PRO 以上才可使用攤位集點
export const PLANS = {
  Free: 1,
  Basic: 2,
  Advanced: 3,
  Pro: 4,
  'Pro+': 5,
  'Pro++': 6,
};
